import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props: any) => (
  <Svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    size={20}
    color="#98A2B3"
    {...props}
  >
    <Path
      d="M8.333 16.667c4.6 0 8.333-3.733 8.333-8.333S12.933 0 8.333 0A8.336 8.336 0 00-.001 8.334c0 4.6 3.734 8.333 8.334 8.333z"
      fill="#98A2B3"
    />
    <Path
      d="M8.742 11.667c.407 0 .74-.333.74-.74V7.962a.743.743 0 00-.74-.74.743.743 0 00-.741.74v2.963c0 .408.333.741.74.741zM8.742 5a.74.74 0 100 1.481.74.74 0 000-1.481z"
      fill="#fff"
    />
  </Svg>
);
export default SVGComponent;
